const MEETING_LINK_ZOOM_PLATFORM = 'https://zoom.us/meeting/register/ApH1tOSYQGmu9EJAaLoBvw#/registration';
const getMeetingUrl = (lang, source, medium, campaign, type) => {
    const getBaseMeetingUrl = () => {
        switch (type) {
            case 'grants-qualification':
            case 'talk-to-sales-premium':
                return MEETING_LINK_ZOOM_PLATFORM;
            case 'grants-qualification-icp':
            case 'talk-to-sales-custom':
                return lang === 'en'
                    ? 'https://go.hellodarwin.com/meetings/hellodarwin/informative-meeting'
                    : 'https://go.hellodarwin.com/meetings/hellodarwin/rencontre-informative-ext';
            case 'grants-qualification-icp-ontario':
            case 'talk-to-sales-custom-roc':
                return lang === 'en'
                    ? 'https://go.hellodarwin.com/meetings/hellod/lets-talk-grants'
                    : 'https://go.hellodarwin.com/meetings/hellod/lets-talk-grants';
            case 'projects':
                return lang === 'en'
                    ? 'https://meetings.hubspot.com/hellodarwin-website/hd-website-discovery-call-link-en'
                    : 'https://meetings.hubspot.com/hellodarwin-website/hd-website-discovery-call-link-fr';
            default:
                return lang === 'en'
                    ? 'https://go.hellodarwin.com/meetings/hellod/platform-presentation'
                    : 'https://go.hellodarwin.com/meetings/hellod/acquisition-client-appel-plateforme-fr';
        }
    };
    const baseMeetingUrl = getBaseMeetingUrl();
    if (!campaign) {
        campaign = 'app';
    }
    const hashIndex = baseMeetingUrl.indexOf('#');
    const linkWithoutHash = hashIndex === -1 ? baseMeetingUrl : baseMeetingUrl.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : baseMeetingUrl.slice(hashIndex);
    const separator = linkWithoutHash.includes('?') ? '&' : '?';
    return `${linkWithoutHash}${separator}utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}${hash}`;
};
export default getMeetingUrl;
